import styles from './primitives/SurfaceGrain.module.css';

/** Class names for shared grain — use with `cx(hostClass, SURFACE_GRAIN.default)` etc. */
export const SURFACE_GRAIN = {
  default: styles.grainDefault,
  overlay: styles.grainOverlay,
} as const;
